<div class="auth-page">
  <a href="#" class="auth-page__home-link" aria-label="Go to home page">
    <i class="fas fa-home"></i>
  </a>

  <div class="auth-card auth-card--wide">
    <div class="auth-card__inner">
      <img src="/assets/images/logoNav.png" class="auth-card__logo" alt="LIC logo" />
      <h4 class="auth-card__heading">Register</h4>
      <p class="auth-card__subheading">ลงทะเบียนผู้ใช้ใหม่</p>
      <div class="auth-card__divider"></div>

      <form class="auth-form" [formGroup]="reactiveForm" novalidate>
        <div class="auth-form__row">
          <div class="auth-form__group">
            <label class="auth-form__label" for="regFirstName">
              First Name *
              <span class="auth-form__label-thai">ชื่อ</span>
            </label>
            <input id="regFirstName" type="text" class="auth-form__input" placeholder="First Name"
              autocomplete="given-name" required formControlName="first_name" />
          </div>
          <div class="auth-form__group">
            <label class="auth-form__label" for="regLastName">
              Last Name *
              <span class="auth-form__label-thai">นามสกุล</span>
            </label>
            <input id="regLastName" type="text" class="auth-form__input" placeholder="Last Name"
              autocomplete="family-name" required formControlName="last_name" />
          </div>
        </div>

        <div class="auth-form__group">
          <label class="auth-form__label" for="regEmail">
            Email *
            <span class="auth-form__label-thai">อีเมล</span>
          </label>
          <input id="regEmail" type="email" class="auth-form__input" placeholder="Email" autocomplete="email" required
            formControlName="email"
            [class.is-invalid]="reactiveForm.get('email').invalid && reactiveForm.get('email').touched" />
          @if ((reactiveForm.get('email').invalid && reactiveForm.get('email').touched) || reactiveForm.get('email').dirty) {
            <div
              >
              @if (f.email.errors?.required) {
                <small class="auth-form__error">Primary email is required</small>
              }
              @if (isAlready && !f.email.errors?.required) {
                <small class="auth-form__error">This email has already been
                taken.</small>
              }
              @if (f.email.errors?.pattern && !isAlready) {
                <small class="auth-form__error">Please provide a valid email
                address</small>
              }
            </div>
          }
        </div>

        <div class="auth-form__group">
          <label class="auth-form__label" for="regConfirmEmail">
            Confirm Email *
            <span class="auth-form__label-thai">ตรวจสอบอีเมล</span>
          </label>
          <input id="regConfirmEmail" type="email" class="auth-form__input" placeholder="Confirm Email"
            autocomplete="email" required formControlName="confirm_email" />
          @if ((reactiveForm.get('confirm_email').invalid && reactiveForm.get('confirm_email').touched) || reactiveForm.get('confirm_email').dirty) {
            <div
              >
              @if (f.confirm_email.errors?.required) {
                <small class="auth-form__error">Primary email is required</small>
              }
              @if (f.confirm_email.errors?.matchEmail) {
                <small class="auth-form__error">Confirm email didn't match</small>
              }
            </div>
          }
        </div>

        <div class="auth-form__row">
          <div class="auth-form__group">
            <label class="auth-form__label" for="regCompany">
              Company Name (If Any)
              <span class="auth-form__label-thai">ชื่อบริษัท</span>
            </label>
            <input id="regCompany" type="text" class="auth-form__input" placeholder="Company Name"
              autocomplete="organization" formControlName="company_name" />
          </div>
          <div class="auth-form__group">
            <label class="auth-form__label" for="regPhone">
              Phone *
              <span class="auth-form__label-thai">เบอร์โทรศัพท์</span>
            </label>
            <input id="regPhone" type="text" (keypress)="numberOnly($event)" class="auth-form__input" placeholder="Phone"
              autocomplete="tel" required formControlName="phone_number" />
          </div>
        </div>

        <div class="auth-form__group">
          <label class="auth-form__label" for="regAddress">
            Address *
            <span class="auth-form__label-thai">ที่อยู่บริษัท</span>
          </label>
          <input id="regAddress" type="text" class="auth-form__input" placeholder="Company Address"
            autocomplete="street-address" required formControlName="company_address" />
        </div>

        <div class="auth-form__row">
          <div class="auth-form__group">
            <label class="auth-form__label" for="regPassword">
              Password *
              <span class="auth-form__label-thai">กำหนดรหัสผ่าน</span>
            </label>
            <div class="auth-form__password-wrapper">
              <input id="regPassword" [type]="isHidePass ? 'password' : 'text'" class="auth-form__input"
                placeholder="Password" autocomplete="new-password" required formControlName="password" />
              <button type="button" class="auth-form__toggle-pass" (click)="isShow('isHidePass')"
                [attr.aria-label]="isHidePass ? 'Show password' : 'Hide password'">
                <i class="fa" [ngClass]="isHidePass ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </div>
            @if (submitted && f.password.errors) {
              <div>
                @if (f.password.errors.required) {
                  <small class="auth-form__error">Password is required</small>
                }
                @if (f.password.errors.minlength) {
                  <small class="auth-form__error">Password at least 5</small>
                }
              </div>
            }
          </div>
          <div class="auth-form__group">
            <label class="auth-form__label" for="regConfirmPassword">
              Confirm Password *
              <span class="auth-form__label-thai">ยืนยันรหัสผ่าน</span>
            </label>
            <div class="auth-form__password-wrapper">
              <input id="regConfirmPassword" [type]="isHideConPass ? 'password' : 'text'" class="auth-form__input"
                placeholder="Confirm Password" autocomplete="new-password" required formControlName="confirm_password" />
              <button type="button" class="auth-form__toggle-pass" (click)="isShow('isHideConPass')"
                [attr.aria-label]="isHideConPass ? 'Show password' : 'Hide password'">
                <i class="fa" [ngClass]="isHideConPass ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </div>
            @if (submitted && f.confirm_password.errors) {
              <div>
                @if (f.confirm_password.errors.required) {
                  <small class="auth-form__error">Confirm password is
                  required</small>
                }
                @if (f.confirm_password.errors.mustMatch) {
                  <small class="auth-form__error">Confirm password didn't
                  match</small>
                }
              </div>
            }
          </div>
        </div>

        <button type="submit" class="auth-form__submit" [disabled]="reactiveForm.invalid" (click)="login()">
          Register
          <span class="auth-form__label-thai">ลงทะเบียนผู้ใช้ใหม่</span>
        </button>
      </form>

      <div class="auth-card__footer">
        <p>เป็นสมาชิกอยู่แล้ว? <a href="/signIn">เข้าสู่ระบบ</a></p>
        <p>Already have an account? <a href="/signIn">Sign in</a></p>
      </div>
    </div><!-- /auth-card__inner -->
  </div>

  <div class="auth-circles" aria-hidden="true">
    <div class="auth-circle auth-circle--1"></div>
    <div class="auth-circle auth-circle--2"></div>
    <div class="auth-circle auth-circle--3"></div>
    <div class="auth-circle auth-circle--4"></div>
  </div>
</div>

<!-- Consent Modal -->
@if (display === 'block') {
  <div class="auth-modal__overlay" role="dialog" aria-modal="true"
    aria-label="Consent agreement">
    <div class="auth-modal__dialog">
      <div class="auth-modal__header">
        <span style="font-weight:600;font-size:1rem;">Consent Agreement</span>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeHandled(false)"></button>
      </div>
      <div class="auth-modal__body" [innerHTML]="content.consent"></div>
      <div class="auth-modal__footer">
        <button type="button" class="auth-modal__btn-reject" (click)="closeHandled(false)">ปฏิเสธทั้งหมด</button>
        <button type="button" class="auth-modal__btn-accept" (click)="closeHandled(true)">ยอมรับทั้งหมด</button>
      </div>
    </div>
  </div>
}

<notifier-container></notifier-container>